import { CategoryEnum } from "@sprawdzonabron/shared";

export const CATEGORY_TO_SLUG: Record<CategoryEnum, string> = {
  [CategoryEnum.All]: "",
  [CategoryEnum.Ammunition]: "amunicja",
  [CategoryEnum.Shotgun]: "strzelby",
  [CategoryEnum.ShortWeapon]: "bron-krotka",
  [CategoryEnum.SpecialOffers]: "oferty-specjalne",
  [CategoryEnum.LongWeapon]: "bron-dluga",
  [CategoryEnum.BlackPowder]: "bron-czarnoprochowa",
};

export const CATEGORY_SLUG_TO_CATEGORY: Record<string, CategoryEnum> = {
  [CATEGORY_TO_SLUG[CategoryEnum.All]]: CategoryEnum.All,
  [CATEGORY_TO_SLUG[CategoryEnum.Ammunition]]: CategoryEnum.Ammunition,
  [CATEGORY_TO_SLUG[CategoryEnum.Shotgun]]: CategoryEnum.Shotgun,
  [CATEGORY_TO_SLUG[CategoryEnum.ShortWeapon]]: CategoryEnum.ShortWeapon,
  [CATEGORY_TO_SLUG[CategoryEnum.SpecialOffers]]: CategoryEnum.SpecialOffers,
  [CATEGORY_TO_SLUG[CategoryEnum.LongWeapon]]: CategoryEnum.LongWeapon,
  [CATEGORY_TO_SLUG[CategoryEnum.BlackPowder]]: CategoryEnum.BlackPowder,
};

// validate that all categories are in both directions
Object.keys(CATEGORY_TO_SLUG).forEach((key) => {
  if (!CATEGORY_SLUG_TO_CATEGORY[CATEGORY_TO_SLUG[key as CategoryEnum]]) {
    throw new Error(`Missing mapping for category ${key}`);
  }
});
